import { TotalCropReportTable, TableContentWithoutEditDateFromat } from '../../../Common/Table/tableContent';
import React from "react";
import tokenService from '../../../../Common/tokenDecoder';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Grid, Card, Container } from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
    render() {

        const reportData = this.props.reportData;
        const months = this.props.months;
        const searchData = this.props.searchData;
        const allTotal = this.props.allTotal;
        const selectedDate = this.props.selectedDate;
        const style = {
            backgroundColor: "#99ccff",
            width: "50px",
            height: "20px",
        };
        const style2 = {
            backgroundColor: "#99ff99",
            width: "50px",
            height: "20px",
        };
        const style3 = {
            backgroundColor: "#ff8566",
            width: "50px",
            height: "20px",
        };
        return (
            <div>
                <h3><center><u>Annual Labour Attendance Monitoring & Average Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b>{searchData.division == undefined ? "All" : searchData.division} </div>
                    <div className="col"><b>Gang: </b>{searchData.gag == undefined ? "All" : searchData.gag} </div>
                    <div className="col"><b>Pluking Type: </b>{searchData.employeeType == "0" ? "All" : searchData.employeeType} </div>
                    <div className="col"><b>Year: </b> {selectedDate.getFullYear()}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>
                <div className="row pl-2 pb-4 pt-4">
                    <Grid container>
                        <Grid style={{ marginLeft: '15px', marginRight: '10px' }}>
                            <b>
                                Daily Plucking Average (Kg) =
                            </b>
                        </Grid>
                        <Grid style={style}>

                        </Grid>
                    </Grid>
                    <Grid style={{ marginTop: '10px' }} container>
                        <Grid style={{ marginLeft: '15px', marginRight: '10px' }}>
                            <b>
                                Daily Plucking Average (Kg) Grater than
                            </b>
                        </Grid>
                        <Grid style={style2}>

                        </Grid>
                    </Grid>
                    <Grid style={{ marginTop: '10px' }} container>
                        <Grid style={{ marginLeft: '15px', marginRight: '10px' }}>
                            <b>
                                Daily Plucking Average (Kg) Less than
                            </b>
                        </Grid>
                        <Grid style={style3}>

                        </Grid>
                    </Grid>
                </div>
                <div>
                    <TableContainer >
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow style={{ border: "2px solid black" }}>
                                    <TableCell align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>Calendar Month</TableCell>
                                    {months.map((count, i) => (
                                        <TableCell key={i} align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>{count.monthName + ' ' + selectedDate.getFullYear()}</TableCell>
                                    ))}
                                    <TableCell align="center" colSpan={2} rowSpan={5} style={{ fontWeight: "bold", border: "2px solid black" }}>Total</TableCell>
                                </TableRow>
                                <TableRow style={{ border: "2px solid black" }}>
                                    <TableCell align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>Actual Days Worked</TableCell>
                                    {months.map((count, i) => {
                                        const result = allTotal.find(x => x.month == count.month)
                                        return (
                                            <>
                                                <TableCell key={i} align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>{result == undefined ? '-' : parseInt(result.actualDays)}</TableCell>
                                            </>
                                        );
                                    })}
                                </TableRow>
                                <TableRow style={{ border: "2px solid black" }}>
                                    <TableCell align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>Total kgs</TableCell>
                                    {months.map((count, i) => {
                                        const result = allTotal.find(x => x.month == count.month)
                                        return (
                                            <>
                                                <TableCell key={i} align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>{result == undefined ? '-' : parseInt(result.total)}</TableCell>
                                            </>
                                        );
                                    })}
                                </TableRow>
                                <TableRow style={{ border: "2px solid black" }}>
                                    <TableCell align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>Total Gang Number</TableCell>
                                    {months.map((count, i) => {
                                        const result = allTotal.find(x => x.month == count.month)
                                        return (
                                            <>
                                                <TableCell key={i} align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>{result == undefined ? '-' : parseInt(result.count)}</TableCell>
                                            </>
                                        );
                                    })}
                                </TableRow>
                                <TableRow style={{ border: "2px solid black" }}>
                                    <TableCell align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>Daily Plucking Average (Kg)</TableCell>
                                    {months.map((count, i) => {
                                        const result = allTotal.find(x => x.month == count.month)
                                        return (
                                            <>
                                                <TableCell key={i} align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>{result == undefined ? '-' : parseInt(result.pluckingAverage)}</TableCell>
                                            </>
                                        );
                                    })}
                                </TableRow>
                                <TableRow style={{ border: "2px solid black" }}>
                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Reg No</TableCell>
                                    <TableCell align="left" style={{ fontWeight: "bold", border: "2px solid black" }}>Employee Name</TableCell>
                                    {months.map((count) => {
                                        return (
                                            <>
                                                <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Work Count</TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Daily Avg kg</TableCell>
                                            </>
                                        );
                                    })}
                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Days</TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Total (kg)</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {reportData.map((row, i) => (
                                    <TableRow style={{ border: "2px solid black" }} key={i}>
                                        <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold", border: "2px solid black" }}> {row.epfNo}</TableCell>
                                        <TableCell component="th" scope="row" align="left" style={{ fontWeight: "bold", border: "2px solid black" }}> {row.firstName}</TableCell>
                                        {months.map((count) => {
                                            const result = row.dataModel.find(x => x.month == count.month)
                                            const result2 = allTotal.find(x => x.month == count.month)
                                            return (
                                                <>
                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold", border: "2px solid black" }}> {result == undefined ? '-' : result.workCount}</TableCell>
                                                    <TableCell
                                                        component="th"
                                                        scope="row"
                                                        style={{
                                                            fontWeight: "bold", border: "2px solid black",
                                                            backgroundColor: result == undefined ? null : (((result2 == undefined ? 0 : parseInt(result2.pluckingAverage)) == (result == undefined ? 0 : parseInt(result.totalAmount / result.workCount))) ? "#99ccff"
                                                                : ((result2 == undefined ? 0 : parseInt(result2.pluckingAverage)) < (result == undefined ? 0 : parseInt(result.totalAmount / result.workCount))) ? "#99ff99" : "#ff8566")
                                                        }}
                                                        align="center"
                                                    >
                                                        {result == undefined ? '-' : parseInt(result.totalAmount / result.workCount)}
                                                    </TableCell>
                                                </>
                                            );
                                        })}
                                        <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} component="th" scope="row" align="center"> {row.totalDays}</TableCell>
                                        <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} component="th" scope="row" align="center"> {row.total}</TableCell>
                                    </TableRow>
                                )
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                <hr />
            </div>
        );
    }
}